import { z } from 'zod/v4';

export enum CategorySpecificationTypeEnum {
    Custom = 'Custom',
}

export enum CustomPartCategorySpecificationTypeEnum {
    PCB = 'PCB',
    Mechanical = 'Mechanical',
    Plastic = 'Plastic',
    Cable = 'Cable',
    Packaging = 'Packaging',
    Label = 'Label',
    Other = 'Other',
}
export const CustomPartCategorySpecificationTypeRuntype = z.enum(CustomPartCategorySpecificationTypeEnum);

export type CategorySpecificationType = z.infer<typeof CategorySpecificationTypeRuntype>;
export const CategorySpecificationTypeRuntype = z.union([
    z.object({
        type: z.literal(CategorySpecificationTypeEnum.Custom),
        data: CustomPartCategorySpecificationTypeRuntype,
    }),
]);

export enum CustomPartCategoryOriginEnum {
    System = 'System',
    User = 'User',
    Import = 'Import',
}

export type CustomPartCategoryOrigin = z.infer<typeof CustomPartCategoryOriginRuntype>;
export const CustomPartCategoryOriginRuntype = z.enum(CustomPartCategoryOriginEnum);

export enum CustomPartCategoryTypeEnum {
    Standard = 'Standard',
    PCB = 'PCB',
}

export type CustomPartCategoryType = z.infer<typeof CustomPartCategoryTypeRuntype>;
export const CustomPartCategoryTypeRuntype = z.enum(CustomPartCategoryTypeEnum);

export type CustomPartCategoryDTO = z.infer<typeof CustomPartCategoryRuntype>;
export const CustomPartCategoryRuntype = z.object({
    id: z.string(),
    category: z.string(),
    identifier: z.string().nullable(),
    description: z.string().nullable(),
    part_specification: CategorySpecificationTypeRuntype,
    origin: CustomPartCategoryOriginRuntype,
    parent: z.string().nullable(),
    category_type: CustomPartCategoryTypeRuntype,
    depth: z.number(),
});

export function isPcbCustomPartCategory(category: CustomPartCategoryDTO): boolean {
    switch (category.part_specification.type) {
        case CategorySpecificationTypeEnum.Custom:
            return category.part_specification.data === CustomPartCategorySpecificationTypeEnum.PCB;
        default:
            return false;
    }
}

export type CustomPartCategoriesDTO = z.infer<typeof CustomPartCategoriesRuntype>;
export const CustomPartCategoriesRuntype = z.object({
    items: z.array(CustomPartCategoryRuntype),
});

export type CustomPartCategoryPostDTO = z.infer<typeof CustomPartCategoryPostRuntype>;
export const CustomPartCategoryPostRuntype = z.object({
    category: z.string(),
    identifier: z.string().nullable(),
    description: z.string().nullable(),
    part_specification: CategorySpecificationTypeRuntype,
    origin: CustomPartCategoryOriginRuntype,
    parent: z.string().nullable(),
});

export type CustomPartCategoryUpdateDTO = z.infer<typeof CustomPartCategoryUpdateRuntype>;
export const CustomPartCategoryUpdateRuntype = z.object({
    category: z.string().optional(),
    identifier: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    part_specification: CategorySpecificationTypeRuntype.optional(),
    origin: CustomPartCategoryOriginRuntype.optional(),
    parent: z.string().nullable().optional(),
});
